import styles from './infoPopup.scss';
import CustomAnchorTag from '../../Common/CommonComponents/CustomAnchorTag/customAnchorTag';

export default class infoPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            infoPopup: false,
            left: 0,
            width: 375
        };
        this.imageInfo = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_infio.svg';
        // this.imageInfo = '../sites/default/files/react_images/infoIcon.png';
        this.popupRef = React.createRef();
        this.savingsLogoIcon = 'wwwsysb.sce.com/sites/default/files/react_images/Savings Programs %26 Tools.svg';
    }
    componentDidMount(){
        document.addEventListener('click', this.handClickOutside);
    }
    componentWillUnmount(){
        document.removeEventListener('click', this.handClickOutside);
    }
    handleClick = (e) => {
        const xPosition = e.clientX;
        const widthParen = e.currentTarget.parentElement.parentElement.offsetWidth;
        this.calculatPosistion(xPosition, widthParen);
    }
    handClickOutside = (event) => {
        if(this.popupRef.current && !this.popupRef.current.contains(event.target)){
            {this.setState({infoPopup: false});}
        }
    };
    getStatusStyle = ()=> {
        switch(this.props.status) {
            case 'Off': return 'not entrolled';
            case 'On': return 'entrolled';
            case 'Pending': return 'Pending';
            default: return 'Ineligible';
        }
    } 

    trackAnalytics = (linkName, isSBP) =>{
        isSBP ? this.props.toggleBillHelp('',isSBP) : this.props.toggleBillHelp();
        let events = {
            alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'Net Energy Metering', search:false
        };
        app.analyticsService.addPageLevelData('eventCapturing', events);
        window.aUtils ? window.aUtils.sendAAEvent("link", `dashboard|none|${isSBP ? 'your_account_balance' : 'none'}|${isSBP ? 'solar billing plan' : 'Net Energy Metering'}|page|${linkName}`) : null;
    }

    openInfoPopup = () => { this.setState((prevState) => ({ infoPopup: !prevState.infoPopup })); }
    toolTipKeyPress= (e) =>{
        if(e.key === "Enter"){
            //this.openInfoPopup();
            const xPosition = e.target.getBoundingClientRect().left;
            const widthParent=e.currentTarget.parentElement.parentElement.offsetWidth;
            this.calculatPosistion(xPosition, widthParent);
        }}
        calculatPosistion = (xPosition, widthParent) => {
            let viewPortWidth = window.innerWidth;
            let halfPortWidth = viewPortWidth/2;
            let widthCalc = Math.min(viewPortWidth * 0.7, 375);
            let popUpWidth = Math.min(viewPortWidth * 0.7, 324);
            let halfPopWidth = popUpWidth/2;
            let leftPosition = 0;
            if(xPosition){
             leftPosition = -(xPosition/halfPortWidth * halfPopWidth);
            }
                
            if(viewPortWidth<=375){
                viewPortWidth = widthParent;
                halfPortWidth = viewPortWidth/2;
                popUpWidth = Math.min(viewPortWidth * 0.6, 220);
                widthCalc = popUpWidth+3;
                halfPopWidth = popUpWidth/2;
                if(xPosition){
                    leftPosition = -(xPosition/halfPortWidth * halfPopWidth);
                }                
            }
            this.setState({
                left: leftPosition,
                width: widthCalc
            });                
            this.openInfoPopup();
    }
    displayContent = (isMobile) => {
        const CONTENT_STRINGS = {
            'NBTratePlanPopup':  'All monthly energy and non-energy charges are due each month. Any remaining Energy Export Credits (EECs) carry over to the next month.',
            'PODID': 'This is an additional customer identification field for your reference for your billing inquiries. The POD ID can also be located near your Service Account number on your bill.'
        };  //NBT3 R2 changes as part of October 2024 release.
        switch (this.props.content) {
            case 'NEM':
                return (
                    <div>
                        <div className={styles.sceInfoPopupContent}>
                            <strong>About the Year-to-Date Energy Charge</strong><br /> If you have a Net Energy Metering (NEM) account with an annual payment option, you don't have energy charges each month. This is because you receive energy credits for the months when you generate more energy than you use.
                        </div>
                        <div className={styles.sceInfoPopupContent}>
                            Your Year-to-Date Energy Charge is the balance of your energy credits and charges. At the end of your 12-month billing period, you'll receive a settlement bill for that balance. You will also receive a monthly bill for your minimum amount due, which supports the cost of the maintenance and operations necessary to provide electricity.
                            <div className={styles.sceFaqLink}><CustomAnchorTag id='nemFAQDSS' isUnderline onClick={()=>this.trackAnalytics('View NEM FAQs')}  linkName='View NEM FAQs' /></div>                            
                        </div>
                    </div>
                );
                case 'PA':
                return (
                    <div className={styles.sceInfoPopupContent}>
                        Payment Arrangement charges may have different amounts and due dates from your new charges. You must pay both your payment arrangement charges and new charges by their respective due dates to avoid service interruption.
                    </div>
                );
                case 'NBT':
                return (
                    <div className={styles.sceInfoPopupContent}>
                        All monthly energy and non-energy charges are due each month. Any remaining Energy Export Credits (EECs) carry over to the next month.
                        <div className={styles.sceFaqLink}><CustomAnchorTag linkName='View SBP FAQs' id='viewSBPFAQ' onClick={()=>this.trackAnalytics('View SBP FAQs', true)} isUnderline /></div>
                    </div>
                );
            case 'RM':
                return (
                    <div>
                        {/* <strong> Repair and Maintenance Alerts</strong> */}
                        <div className={'sce-space-xs ' + [styles.sceInfoPopupContent,styles.alignPopup].join(" ")}>
                            Receive status updates for an unplanned <CustomAnchorTag link='/outage-center/outage-information' linkName='repair outage' />, including when they start, why they happen, and when power will be restored. We'll also alert you of planned <CustomAnchorTag link='/outage-center/outage-information' linkName='maintenance outage' />, including when they'll happen, advanced reminders, and scheduling updates.
                        </div>
                    </div>
                );
            case 'EA':
                return (
                    <div>
                        {/* <strong> Emergency Alerts</strong> */}
                        <div className={'sce-space-xs ' + styles.sceInfoPopupContent + ' '}>
                            Receive status updates approximately 48 hours prior to potential <CustomAnchorTag link='/wildfire' linkName='Public Safety Power Shutoff (PSPS)' /> events, which may occur during extreme or possibly dangerous weather conditions, or in the rare event the California Independent System Operator (CAISO) initiates a statewide Stage 3 Emergency requiring  <CustomAnchorTag link='/outage-center/outage-information/rotating-outages' linkName='Rotating Outage' />.
                        </div>
                    </div>
                );
            case 'CPP':
                return (
                    <div>
                        {/* <strong> Critical Peak Pricing Notifications </strong> */}
                        <div className={'sce-space-xs ' + styles.sceInfoPopupContent + ' '}>
                        CPP provides four months of summer season bill credits in exchange for being billed at higher energy prices during 12 - 15 CPP demand response events per year. When called, CPP events are from 4 p.m. – 9 p.m., usually on the hottest summer days. By reducing your electricity usage during CPP events, you can minimize the impacts of higher energy prices.
                        </div>
                        <div className={'sce-space-xs ' + styles.sceInfoPopupContent + ' '}>
                        Notifications help you plan for CPP events. We will alert you the day prior to a CPP event by phone, email, or text.
                        </div>
                        <CustomAnchorTag link='/business/rates/cpp' linkName='Learn more' sceLearnMore />
                    </div>
                );
            case 'BA':
                return (
                    <div>
                        {/* <strong> Budget Assistant Notifications </strong> */}
                        <div className={'sce-space-xs ' + styles.sceInfoPopupContent + ' '}>
                        In addition to helping you manage your energy usage and costs, Budget Assistant will send you progress alerts. Set one spending goal for summer and one for winter, to help manage your costs all year.
                         </div>
                        <CustomAnchorTag link='/residential/rebates-savings/budget-assistant-and-you' linkName='Learn more' sceLearnMore />
                    </div>
                );
                case 'NBA':
                return (
                    <div>
                        {/* <strong> Budget Assistant Notifications </strong> */}
                        <div className={'sce-space-xs ' + styles.sceInfoPopupContent + ' '}>
                        In addition to helping you manage your energy usage and costs, Budget Assistant will send you progress alerts. Set one spending goal for summer and one for winter, to help manage your costs all year.
                         </div>
                        <CustomAnchorTag link='/residential/rebates-savings/budget-assistant-and-you' linkName='Learn more' sceLearnMore />
                    </div>
                );
            case 'PB':
                return (
                    <div>
                        <div className={'sce-space-xs ' + styles.sceInfoPopupContent + ' '}> Enjoy the benefits of Paperless Billing: </div>
                        <ul className={styles.sceInfoPopupContent}>
                            <li> Receive an email alert when your bill is ready and 19 days before it is due.</li>
                            <li> View up to 36 months of your bills online.</li>
                         </ul>
                        <CustomAnchorTag link='/helpcenter/topics/account-bills/how-do-i-sign-paperless-billing' linkName='Learn more' sceLearnMore />
                    </div>
                );
            case 'AP':
                return (
                    <div className={[styles.sceInfoPopupContent,styles.sceAlignContentLeft].join(" ")}>
                        Auto Pay automatically deducts your total amount due from your bank account 10 days after your bill is generated, so you don’t have to remember to pay it each month.
                    </div>
                );
            case 'YOURBILLAP':
                return (
                    <div className={[styles.sceInfoPopupContent, styles.sceAlignContentLeft].join(" ")}>
                        Auto Pay automatically deducts your total amount due from your bank account 10 days after your bill is generated, so you don’t have to remember to pay it each month.
                    </div>
                );
            case 'ROG':
                return (
                    <div className={styles.sceInfoPopupContent}>
                        Rotating Outages help avoid widespread or uncontrolled blackouts during system emergencies. SCE accounts in groups A, M, R, S and X are subject to rotating outages. Group can change, without notice, at any time.
                    </div>
                );
            case 'SDP':
                return (
                    <div>
                    <div className={styles.sceInfoPopupContent}>
                        Sign up for the Summer Discount Plan (SDP) and earn up to $180 in bill credits. </div>
                        <CustomAnchorTag link={'/residential/rebates-savings/summer-discount-plan'} linkName='Learn more' sceLearnMore />
                    </div>
                );
            case 'SDPC':
                return (
                    <div>
                    <div className={styles.sceInfoPopupContent}>
                        Sign up for the Summer Discount Plan (SDP) and earn up to $180 in bill credits. </div>
                        <CustomAnchorTag link={'/residential/rebates-savings/summer-discount-plan'} linkName='Learn more' sceLearnMore />
                    </div>
                );
            case 'SEP':
                return (
                    <div>
                    <div className={styles.sceInfoPopupContent}>
                        Enroll your qualified smart thermostat in our Smart Energy Program and earn up to $115 in bill credits for participating in Smart Energy Program energy events. 
                    </div>
                    <CustomAnchorTag link={'/residential/demand-response/smart-energy-program'} linkName='Learn more' sceLearnMore />
                    </div>
                );
            case 'CRFR':
                return (
                    <div>
                    <div className={styles.sceInfoPopupContent}>
                        Our Family Electric Rate Assistance (FERA) and California Alternate Rates for Energy (CARE) financial assistance programs help qualified families of all sizes lower their monthly energy bills.  
                    </div>
                    <CustomAnchorTag link={'/residential/assistance/fera-care'} linkName='Learn more' sceLearnMore />
                    </div>
                );
            case 'RIN':
            return (
                <div className={styles.sceInfoPopupContent}>
                    If you have smart device, such as a smart thermostat, an EV charger, or an energy management system, you may be able to use this Rate Identification Number (RIN) to program your device to manage your electricity usage. For additional information, go to <CustomAnchorTag link={'/helpcenter/rin'} linkName='/helpcenter/rin' sceLearnMore />
                </div>
            );
            case 'MND':
            return (
                <div className={styles.sceInfoPopupContent}>
                    Click "Manage Accounts Display" to select how many customer accounts you want displayed on your My Account Pages.
                </div>
            );
            case 'ROGMNG':
                return (
                    <div className={styles.sceInfoPopupContent}>
                        Rotating Outages help avoid widespread or uncontrolled blackouts during system emergencies. SCE accounts in groups A, M, R, S and X are subject to rotating outages. Group can change, without notice, at any time.
                    </div>
                );
            default :
            return (
                <div className={styles.sceInfoPopupContent}>  
                    {CONTENT_STRINGS[this.props.content]}
                </div> //NBT3 R2 changes as part of October 2024 release.
            );
        }
    }
    displayContentPNB = (isMobile) => {
        switch (this.props.content) {
            case 'CC':
            return (
                <div className={styles.sceInfoPopupContent}>
                    Customers may receive a climate credit on their April or October bill, and bill projections will be adjusted accordingly. For details, visit our <CustomAnchorTag link='/customer-service-center/help-center/billing-payments/understand-your-bill/california-climate-credit-bill-impact' linkName='Help Center' />
                </div>
            );
            case 'BB':
            return (
                <div className={styles.sceInfoPopupContent}>
                    The projected next bill is based on actual usage and charges, not your budget bill amount.
                </div>
            );        
        }
    }
    render() {
        const isMobile = app.appUtil.detectMobile();
        const isSavingsProg = ['SDP', 'SEP', 'CRFR', ].includes( this.props.content ) ? true : false;
        const isBnp = ['PB', 'AP'].includes( this.props.content ) ? true : false;
        const icon = this.props.attachedToIcon ? <span className={styles.sceWrapperIconSec}>{this.props.attachedToIcon} <img className={styles.sceInfoIcon} src={this.imageInfo} alt="Info Icon" onClick={(e)=>this.handleClick(e)} tabIndex={0} onKeyPress={(e)=> this.toolTipKeyPress(e)} /></span> : <img className={styles.sceInfoIcon} src={this.imageInfo} alt="Info Icon" onClick={(e)=>this.handleClick(e)} tabIndex={0} onKeyPress={(e)=> this.toolTipKeyPress(e)} />;
        return (
            <div className={styles.sceSubHead} ref={this.popupRef}>
            <span className={styles.sceWrapper}>{this.props.heading} {icon}
            {this.state.infoPopup ? <span className={`${styles.sceTooltip} ${ this.props.content === 'RM' ? styles.sceCustomAlignmentPopup : this.props.content === 'PB' ? styles.sceCustomAlignPB : this.props.content === 'EA' ? styles.sceCustomAlignEA : null} ${this.props.content === 'NBTratePlanPopup' ? styles.sceTooltipIcon : null}`}><span style={{ width: `${this.state.width}px`, left: `${this.state.left}px` }} className={`${isSavingsProg||isBnp ? isMobile ? styles.sceSavingsMbContent : styles.sceSavingsContent : isMobile ? this.props.content==="NBA"?styles.sceMobNBA:styles.sceMobContent : this.props.content==="MND"?styles.sceManageDisplay:this.props.content==="ROGMNG"?styles.sceMngPopup:this.props.content === 'NBA'?styles.sceCustomAlignNBA:styles.sceContent} ${this.props.content === 'NBTratePlanPopup' ? styles.sceTooltipBottom : null}`}> {this.props.content === 'BB' || this.props.content === 'CC' ? this.displayContentPNB(isMobile) : this.displayContent(isMobile)} </span> </span> : null }
            </span>
            {/* <span class={styles[this.props.status]}>{this.getStatusStyle()}</span> */}
            </div>
        );
    }
}

